import router from "./../../router";
import axios from 'axios';
const noretryAuthAxios = axios.create();
noretryAuthAxios.defaults.baseURL = 'https://api.piachu.net/';

const state = {
    token: '',
    users_id: '',
    user_type: '',
    identification_flg: '',
};

const getters = {
    token: state => state.token,
    user_type: state => state.user_type,
    identification_flg: state => state.identification_flg,
}

const mutations = {
    login (state, payload) {
        state.token = payload["access_token"];
        state.users_id = payload["users_id"];
        state.user_type = payload["user_type"];
        state.identification_flg = payload["identification_flg"];
    },
    logout (state) {
        state.token = null;
        state.users_id = null;
        state.user_type = null;
        state.identification_flg = null;
    }
};

const actions = {

    async pre_regist ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            noretryAuthAxios.post('/api/pre_regist', {
                users: payload.users,
            }).then(res => {
                resolve(res);
                // commit('alert/setAlert', { 'message': '会員登録に成功しました。' }, { root: true });
            }).catch(error => {
                //commit('alert/setAlert', { 'message': '仮登録に失敗しました。', 'type': 'danger' }, { root: true });
                console.log(error);
                reject(error);
            });
        });
    },

    async email_token_check ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            noretryAuthAxios.get('/api/register/verify/'+payload.token).then(res => {
                console.log(res);
                const token = {};
                token["access_token"] = res.data.access_token;
                token["users_id"] = res.data.users_id;
                token["user_type"] = res.data.user_type;
                token["identification_flg"] = res.data.identification_flg;
                console.log("regist token!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
                console.log(token);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token["access_token"];
                commit('login', token);
                resolve(res);
                // commit('alert/setAlert', { 'message': '会員登録に成功しました。' }, { root: true });
            }).catch(error => {
                //commit('alert/setAlert', { 'message': 'メール認証に失敗しました。', 'type': 'danger' }, { root: true });
                console.log(error);
                reject(error);
            });
        });
    },

    logout ({ commit }) {
        axios.post('/api/logout').then(res => {
            axios.defaults.headers.common['Authorization'] = '';
            localStorage.clear();
            commit('logout');
            router.push({path: '/'});
        }).catch(error => {
            axios.defaults.headers.common['Authorization'] = '';
            commit('logout');
        });
    },

    async login ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            noretryAuthAxios.post('/api/login', {
                email: payload.email,
                password: payload.password
            }).then(res => {
                const token = {};
                token["access_token"] = res.data.access_token;
                token["users_id"] = res.data.users_id;
                token["user_type"] = res.data.user_type;
                token["identification_flg"] = res.data.identification_flg;
                console.log("login token!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
                console.log(token);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token["access_token"];
                commit('login', token);
                if ( localStorage.getItem("beforeUrl") != null && localStorage.getItem("beforeUrl") != "/login" ) {
                    router.push({path: localStorage.getItem("beforeUrl")});
                } else {
                    router.push({path: '/mypage'});
                    // if(res.data.user_type === 1) {
                    //     router.push({path: '/mypage'});
                    // } else if(res.data.user_type === 2) {
                    //     router.push({path: '/search/writer'});
                    // }
                }
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async change_password_application ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            noretryAuthAxios.post('/api/change_password_application', {
                mail: payload.email,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async change_password ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            noretryAuthAxios.post('/api/change_password', {
                password: payload.password,
                token: payload.token,
            }).then(res => {
                resolve(res);
                // const token = {};
                // token["access_token"] = res.data["auth"]["original"]["access_token"];
                // token["users_id"] = res.data["auth"]["original"]["users_id"];
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + token["access_token"];
                // commit('login', token);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async identification({commit}, payload) {
        // for (var [key, value] of payload.formData.entries()) {
        //     console.log(key, value);
        //   }
        await new Promise((resolve, reject) => {
            axios.post('/api/identifications', payload.formData, {
                headers: {'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2) + ';',}
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        })
    },



    auth_error_logout ({ commit }) {
        axios.defaults.headers.common['Authorization'] = '';
        commit('logout');
        router.push({path: '/login'});
    },

    system_error_logout ({ commit }) {
        axios.defaults.headers.common['Authorization'] = '';
        commit('logout');
        router.push({path: '/login'});
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js